module.exports = __webpack_public_path__ + "static/media/storePurchase_15_20.db343ef4.png";